import { useMemo } from 'react';
import type { Task } from 'src/api/generated/models/Task';
import { isTaskOverdue } from 'src/modules/shared/utils/tasks/date.util';

/**
 * Hook to count the number of overdue tasks from a list of tasks
 * @param tasks Array of tasks to analyze
 * @returns Number of overdue tasks
 */
export const useOverdueTasksCount = (tasks: Task[]): number => {
  return useMemo(() => {
    const overdueTasks = tasks.filter((task) => isTaskOverdue(task));
    return overdueTasks.length;
  }, [tasks]);
};
